import { capitalize, isEmpty } from "lodash";
import HelperUtils from "../HelperUtils";
import html2canvas from 'html2canvas';
import { formatPhone, formatSSN, getLabelType, isDate } from "./helpers";
import moment from "moment";
import DateTimeUtils from "../DateTimeUtils";
import ImageUtils from "./imageUtils";

export default class DataUtils {
  static printPatientDemographics = (patientDetails, myWindow, referralDetails, currentUser) => {
    var myStringOfstyles =
      'body { margin: 0; width: 210mm; height: 296mm; }' +
      ' .sheet-outer { margin: 0; }' +
      ' .sheet { margin: 0; padding: 4 12; overflow: hidden; position: relative; box-sizing: border-box;page-break-after: always;}' +
      ' .sheet-outer.A4 .sheet {  width: 210mm; height: 296mm }';

    if (myWindow === null) {
      myWindow = window.open();
      myWindow.document.body.style.width = '216mm';
      myWindow.document.body.style.margin = '0';
    }
    var linkElement = myWindow.document.createElement('link');
    linkElement.setAttribute('rel', 'stylesheet');
    linkElement.setAttribute('type', 'text/css');
    linkElement.setAttribute(
      'href',
      'data:text/css;charset=UTF-8,' + encodeURIComponent(myStringOfstyles),
    );

    myWindow.document.head.innerHTML +=
      '<link rel="stylesheet" href="styles.css" type="text/css"/>';
    myWindow.document.body.innerHTML += DataUtils.patientDemographicsPage(
      patientDetails,
      referralDetails,
      currentUser,
    );
  };

  static appendReferralDetails = async (
    patientDetails,
    doc,
    referralDetails,
    documents,
    resolveVal,
    filename,
    currentUser,
    is_fax,
  ) => {
    let iframe = window.document.createElement('iframe');
    iframe.style.visibility = 'hidden';
    iframe.style.width = '216mm';
    iframe.style.margin = '0';
    window.document.body.appendChild(iframe);
    let iframedoc = iframe.contentDocument || iframe.contentWindow.document;
    var innerHTML = DataUtils.patientDemographicsPage(
      patientDetails,
      referralDetails,
      currentUser,
      is_fax,
    );
    iframedoc.body.innerHTML = innerHTML;

    let canvas = await html2canvas(iframedoc.body, {
      scale: 2,
      useCORS: true,
      logging: true,
      allowTaint: true,
    });

    let imgData = canvas.toDataURL('image/jpeg');

    var percent = doc.internal.pageSize.getWidth() / canvas.width;
    doc.addImage(
      imgData,
      'JPEG',
      0,
      0,
      doc.internal.pageSize.getWidth(),
      percent * canvas.height,
      null,
      'MEDIUM',
    );

    let blob = doc.output('blob');
    window.document.body.removeChild(iframe);
    if (!isEmpty(documents) && documents[documents.length - 1]?.type === 'application/pdf') {
      ImageUtils.appendDocuments(documents, doc, resolveVal, filename);
    } else if (!isEmpty(documents)) {
      ImageUtils.appendImages(documents, doc, resolveVal, filename);
    } else {
      resolveVal(blob);
      if (!isEmpty(filename)) {
        doc.autoPrint();
        doc.output('dataurlnewwindow');
      }
    }
  };

  static patientDemographicsReferral = patient => {
    var innerHTML = '';
    if (isEmpty(patient)) {
      return innerHTML;
    }
    innerHTML +=
      "<section class='sheet' style='padding: 4 12;' ><span style='font-weight: bold;'>Patient Name : </span>" +
      "<span style='text-decoration: underline;'>" +
      (!isEmpty(patient?.full_name) ? patient.full_name : 'N/A') +
      '</span></section>';

    innerHTML +=
      "<section class='sheet' style='padding: 4 12;'><span style='font-weight: bold;'>Address : </span>" +
      "<span style='text-decoration: underline;'>" +
      (!isEmpty(patient?.full_address) ? patient.full_address : 'N/A') +
      '</span></section>';

    innerHTML +=
      "<section class='sheet' style='padding: 4 12;'><span style='font-weight: bold;'>Phone : </span>" +
      "<span style='text-decoration: underline;'>" +
      formatPhone(patient?.phone) +
      '</span></section>';

    innerHTML +=
      "<section class='sheet' style='padding: 4 12;'><span style='font-weight: bold;'>SSN : </span>" +
      "<span style='text-decoration: underline;'>" +
      formatSSN(patient?.ssn) +
      '</span></section>';

    innerHTML +=
      "<section class='sheet' style='padding: 4 12;'><span style='font-weight: bold;'>DOB : </span>" +
      "<span style='text-decoration: underline;'>" +
      (!isEmpty(patient?.birthdate) ? patient.birthdate : 'N/A') +
      '</span></section>';

    innerHTML +=
      "<section class='sheet' style='padding: 4 12;'>" +
      "<span style='font-weight: bold;'>Primary Insurance : </span>" +
      "<span style='text-decoration: underline;'>" +
      (!isEmpty(patient?.insurance_provider) ? patient.insurance_provider : 'N/A') +
      '</span>' +
      "<span style='font-weight: bold;'>&ensp;&ensp;ID #: </span>" +
      "<span style='text-decoration: underline;'>" +
      (!isEmpty(patient?.policy_number) ? patient.policy_number : 'N/A') +
      '</span>' +
      '</section>';

    return innerHTML;
  };

  static receivingClinicDetails = referral => {
    var innerHTML = '';

    innerHTML +=
      "<section class='sheet' style='padding: 4 12;'><span style='font-weight: bold;'>" +
      (!isEmpty(referral.provider?.display_name)
        ? referral.provider.display_name +
        (referral.provider.display_name !== 'Any/First Available' ? ' M.D.' : '')
        : 'N/A') +
      '</span></section>';

    innerHTML +=
      "<section class='sheet' style='padding: 4 12;'><span style='font-weight: bold;'>" +
      (!isEmpty(referral.provider?.specializations)
        ? referral.provider.specializations
          .map(item => capitalize(item['name']))
          .join(', ')
        : 'N/A') +
      '</span></section>';

    innerHTML +=
      "<section class='sheet' style='padding: 4 12;'><span style='font-weight: bold;'>" +
      (!isEmpty(referral.receiver?.name) ? referral.receiver?.name : 'N/A') +
      '</span></section>';

    return innerHTML;
  };

  static receivingComment = referral => {
    var innerHTML = '';

    innerHTML +=
      "<section class='sheet' style='padding: 4 12;'><span style='font-weight: bold;'>Additional Comment : </span>" +
      "<span style='text-decoration: underline;'>" +
      (!isEmpty(referral.comment) ? referral.comment : 'N/A') +
      '</span></section>';

    return innerHTML;
  };

  static referralExtraInfo = referral => {
    var innerHTML = '';
    var extra_info = JSON.parse(referral.extra_info);
    if (!isEmpty(extra_info)) {
      for (const [key, value] of Object.entries(extra_info)) {
        if (Object.prototype.toString.call(value).indexOf('Array') > -1) {
          innerHTML +=
            "<section class='sheet' style='padding: 4 12;'><span style='font-weight: bold;'>" +
            capitalize(key.replaceAll('custom_', '').replaceAll("_", " ")) +
            ' : </span>';
          if (isEmpty(value)) {
            innerHTML += "<span style='text-decoration: underline;'>N/A</span>";
          }
          innerHTML += value
            .map((val) => "<span style='text-decoration: underline;'>" + capitalize(val) + '</span>')
            .join(', ');

          innerHTML += '</section>';
        } else {
          innerHTML +=
            "<section class='sheet' style='padding: 4 12;'><span style='font-weight: bold;'>" +
            capitalize(key.replaceAll('custom_', '').replaceAll("_", " ")) +
            ' : </span>';

          if (isEmpty(value)) {
            innerHTML += "<span style='text-decoration: underline;'>N/A</span>";
          } else if (isDate(value) && value.length > 10) {
            innerHTML += "<span style='text-decoration: underline;'>" + value.substring(0, 10) + '</span>';
          } else {
            innerHTML += "<span style='text-decoration: underline;'>" + value + '</span>';
          }

          innerHTML += '</section>';
        }
      }
    }

    return innerHTML;
  };

  static printDiagnosis = referral => {
    var innerHTML = '';

    innerHTML +=
      "<section class='sheet' style='padding: 4 12;'><span style='font-weight: bold;'>DIAGNOSIS : </span>" +
      "<span style='font-weight: bold;'>" +
    (!isEmpty(referral?.diagnosis) ? referral.diagnosis?.description.toUpperCase() : 'N/A') +
      '</span></section>';

    return innerHTML;
  };

  static patientDemographicsPage = (patientDetails, referralDetails, currentUser, is_fax) => {
    var innerHTML = '';
    var referral = {};
    var patient = {};

    if (!isEmpty(patientDetails) && !isEmpty(patientDetails.patient)) {
      patient = patientDetails.patient;
    }

    if (!isEmpty(referralDetails?.referral) && isEmpty(referralDetails?.referral?.referral)) {
      referral = referralDetails?.referral;
    } else if (!isEmpty(referralDetails?.referral?.referral)) {
      referral = referralDetails?.referral?.referral;
    } else {
      return;
    }
    innerHTML += DataUtils.getHeader(is_fax, referral);

    innerHTML += DataUtils.getReferreringClinic(referral);

    innerHTML += DataUtils.getAddress(referral);

    innerHTML += DataUtils.getContactPerson(referral, currentUser);

    innerHTML += DataUtils.getFaxAndPhoneNumber(referral);

    innerHTML += '<hr/>';

    innerHTML += DataUtils.receivingClinicDetails(referral);

    innerHTML += '<hr/>';

    innerHTML +=
      "<section class='sheet' style='padding: 4 12;'><span style='font-weight: bold;'>" + getLabelType(referral?.is_order, true) + " Date : </span>" +
      "<span style='text-decoration: underline;'>" +
      (!isEmpty(referral.sent_at)
        ? moment(referral.sent_at, 'YYYY-MM-DD HH:mm:ss')
          .local()
          .format('YYYY-MM-DD')
        : DateTimeUtils.now().format('YYYY-MM-DD')) +
      '</span></section>';

    innerHTML += DataUtils.patientDemographicsReferral(patient);

    innerHTML += DataUtils.referralExtraInfo(referral);

    innerHTML += DataUtils.printDiagnosis(referral);

    innerHTML += DataUtils.receivingComment(referral);

    innerHTML += '<hr/>';

    if (referral?.is_order) {
      if (referral.status !== 'draft' || referral.status !== 'pending_approval') {
        innerHTML +=
          "<section class='sheet' style='padding: 4px 12px;'>" +
          "<span style='font-weight: bold;'>Order approved by: </span>" +
          "<span>" + referral.approver_name + "</span><br>" +
          (referral.signature_url
            ? "<img src='" + referral.signature_url + "' alt='Signature' style='max-height:50px; margin-top:4px;' />"
            : "<em>No signature available</em>") +
          "</section>";
      } else {
        innerHTML +=
          "<section class='sheet' style='padding: 4px 12px;'>" +
          "<span style='font-weight: bold;'>Order not yet approved</span>" +
          "</section>";
      }
    } else {
    }

    innerHTML += '</div></body></html>';

    return innerHTML;
  };

  static getHeader(is_fax, referral) {
    var innerHTML = "<!DOCTYPE html><html><body><div class='sheet-outer A4'>";
    innerHTML += "<div class='sheet-outer A4'>";
    innerHTML += "<section class='sheet' style='padding: 4 12; margin-left: 220;'>";
    if (is_fax) {
      innerHTML +=
        "<img src='/static/media/black-logo.8688d0e1.png' style=' width: 300; height: 66; object-fit: cover; transition-property: opacity; transition-duration: 0ms; transition-timing-function: cubic-bezier(0.7, 0, 0.6, 1); opacity: 1; animation: 0ms cubic-bezier(0.7, 0, 0.6, 1) 0s 1 normal none running materialize; -webkit-filter: grayscale(1) invert(1);filter: grayscale(1) invert(1);' />";
      innerHTML += '</section>';
      innerHTML +=
        "<section class='sheet' style='padding: 4 12; margin-left: 100;'><h2 style='font-style: italic; font-size: 1.5em;'>Want to get this referral online? contact@ziprefer.com</h2></section>";
    } else {
      innerHTML +=
        "<img src='/static/media/ziprefer-transparent.43b797ae.png' style=' width: 300; height: 66; object-fit: cover; transition-property: opacity; transition-duration: 0ms; transition-timing-function: cubic-bezier(0.7, 0, 0.6, 1); opacity: 1; animation: 0ms cubic-bezier(0.7, 0, 0.6, 1) 0s 1 normal none running materialize; -webkit-filter: grayscale(1) invert(1);filter: grayscale(1) invert(1);' />";
      innerHTML += '</section>';
      innerHTML +=
        "<section class='sheet' style='padding: 4 12; margin-left: 210;'><h4 style='font-style: italic;'>This " + getLabelType(referral?.is_order, false) + " has been brought to you by ZipRefer!</h4></section>";
    }

    return innerHTML;
  }

  static getReferreringClinic(referral) {
    var innerHTML =
      "<section class='sheet' style='padding: 4 12;'><span style='font-weight: bold;'>Referring Clinic : </span>" +
      "<span style='text-decoration: underline;'>";
    if (!isEmpty(referral.referrer?.name)) {
      innerHTML += referral.referrer?.name;
    } else {
      innerHTML += 'N/A';
    }
    innerHTML += '</span></section>';
    return innerHTML;
  }

  static getAddress(referral) {
    var innerHTML =
      "<section class='sheet' style='padding: 4 12;'><span style='font-weight: bold;'>Address : </span>" +
      "<span style='text-decoration: underline;'>";
    if (!isEmpty(referral.referrer?.full_address)) {
      innerHTML += referral.referrer?.full_address;
    } else {
      innerHTML += 'N/A';
    }
    innerHTML += '</span></section>';
    return innerHTML;
  }

  static getContactPerson(referral, currentUser) {
    var innerHTML =
      "<section class='sheet' style='padding: 4 12;'><span style='font-weight: bold;'>Contact : </span>" +
      "<span style='text-decoration: underline;'>";
    if (!isEmpty(referral) && !isEmpty(referral.referrer?.referrer_name)) {
      innerHTML += referral.referrer?.referrer_name;
    } else if (!isEmpty(currentUser)) {
      innerHTML += currentUser.firstname + ' ' + currentUser.lastname;
    } else {
      innerHTML += 'N/A';
    }
    innerHTML +=
      '</span>' +
      "<span style='font-weight: bold;'>&ensp;&ensp;E-mail Address : </span>" +
      "<span style='text-decoration: underline;'>";

    if (!isEmpty(referral) && !isEmpty(referral.referrer?.referrer_email)) {
      innerHTML += referral.referrer?.referrer_email;
    } else if (!isEmpty(currentUser)) {
      innerHTML += currentUser.email;
    } else {
      innerHTML += 'N/A';
    }

    innerHTML += '</span></section>';
    return innerHTML;
  }

  static getFaxAndPhoneNumber(referral) {
    var innerHTML =
      "<section class='sheet' style='padding: 4 12;'><span style='font-weight: bold;'>Fax # : </span>" +
      "<span style='text-decoration: underline;'>";
    if (!isEmpty(HelperUtils.getReferrerFaxNumber(referral))) {
      innerHTML += HelperUtils.getReferrerFaxNumber(referral);
    } else {
      innerHTML += 'N/A';
    }
    innerHTML +=
      '</span>' +
      "<span style='font-weight: bold;'>&ensp;&ensp;Phone # : </span>" +
      "<span style='text-decoration: underline;'>";

    if (!isEmpty(HelperUtils.getReferrerPhone(referral))) {
      innerHTML += HelperUtils.getReferrerPhone(referral);
    } else {
      innerHTML += 'N/A';
    }

    innerHTML += '</span></section>';
    return innerHTML;
  }
}
